import React, { useContext } from "react";
import {
  ApiErrorHandler,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import Toggle from "../../../common/Toggle/Toggle";
import { IGroupInfo, IPatientChats } from "@home-health-notify/domain";
import { IUpdateVisibleToPatientRequest } from "@home-health-notify/models";
import { useSnackbar } from "notistack";

const VisibleToPatientToggle = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });

  const visibleToPatient = groupInfo.settings?.visibleToPatient || false;
  const { selectedOrgUser } = useContext(OrganizationContext);
  const { enqueueSnackbar } = useSnackbar();

  const getRequestPayload = () => {
    const requestPayload: IUpdateVisibleToPatientRequest = {
      id: groupInfo.id,
      settings: {
        visibleToPatient: !visibleToPatient,
      },
    };
    return requestPayload;
  };

  const onVisibleToPatient = async () => {
    try {
      const chatManager =
        selectedOrgUser?.chatManager.getChatManagerForGroupType(
          groupInfo.groupType,
        ) as IPatientChats;
      await chatManager.updateVisibleToPatient(getRequestPayload());
      enqueueSnackbar("Visible to patient has been updated", {
        autoHideDuration: 3000,
      });
    } catch (e) {
      ApiErrorHandler(e, enqueueSnackbar);
    }
  };

  return (
    <Toggle
      label={tNs("visibleToPatient")}
      onToggle={onVisibleToPatient}
      checked={visibleToPatient}
    />
  );
};

export default VisibleToPatientToggle;
